import CircularProgress from "@mui/material/CircularProgress";

export const Loader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        paddingTop: "50px",
        paddingBottom: "50px",
      }}
    >
      <CircularProgress />
    </div>
  );
};
